import React from "react";

interface WebSearchToolBlockProps {
  query: string;
}

export const WebSearchToolBlock: React.FC<WebSearchToolBlockProps> = React.memo(
  ({ query }) => {
    return (
      <div className="text-xs text-secondary-n-400">
        <div className="font-mono">{query}</div>
      </div>
    );
  },
);
